module.exports = __webpack_public_path__ + "img/chargingport_1000.2b194362.png";